import mainArt from "./group1.png"

const headerAssets = {
    mainArt
}

export default headerAssets